import { useMemo } from 'react'

import { HealthPlansList, YearProgramCoverage } from '../../../models'
import { ProgramCustomerPropertyId } from '../../common/constants/customerProgram'

export const useHealthPlanAndEligibilityData = ({
  programCoverageBreakdown,
  isAlcoholUseDisorderTherapyEnabled,
  isBlendedCareMedsAvailable,
  isLCTherapyAvailable,
  isCoachingEnabled,
  isCoachingForParentsEnabled,
  isDAMedsAvailable,
  isDirectAccessTherapySupported,
  isGuidedSelfCareEnabled,
  isClinicalLeaveEvaluationEnabled,
  healthPlanData,
  healthPlanConfig,
}: {
  programCoverageBreakdown?: YearProgramCoverage
  isAlcoholUseDisorderTherapyEnabled: boolean
  isBlendedCareMedsAvailable: boolean
  isLCTherapyAvailable: boolean
  isCoachingEnabled: boolean
  isCoachingForParentsEnabled: boolean
  isDAMedsAvailable: boolean
  isDirectAccessTherapySupported: boolean
  isGuidedSelfCareEnabled: boolean
  isClinicalLeaveEvaluationEnabled: boolean
  healthPlanData?: Dict
  healthPlanConfig?: HealthPlansList
}) => {
  return useMemo(() => {
    const healthPlanAndEligibilityData: {
      programCoverageBreakdown?: YearProgramCoverage
      programDetails: { [key in ProgramCustomerPropertyId]?: { isEnabled: boolean } }
      healthPlanInformation: {
        healthPlanData?: Dict
        healthPlanConfig?: HealthPlansList
      }
    } = {
      programCoverageBreakdown,
      programDetails: {
        [ProgramCustomerPropertyId.alcoholUseDisorderTherapy]: {
          isEnabled: isAlcoholUseDisorderTherapyEnabled,
        },
        [ProgramCustomerPropertyId.blendedCareMeds]: {
          isEnabled: isBlendedCareMedsAvailable,
        },
        [ProgramCustomerPropertyId.considerLyraTherapy]: {
          isEnabled: isLCTherapyAvailable,
        },
        [ProgramCustomerPropertyId.stressManagement]: {
          isEnabled: isCoachingEnabled,
        },
        [ProgramCustomerPropertyId.coachingForParents]: {
          isEnabled: isCoachingForParentsEnabled,
        },
        [ProgramCustomerPropertyId.considerMeds]: {
          isEnabled: isDAMedsAvailable,
        },
        [ProgramCustomerPropertyId.directAccessTherapy]: {
          isEnabled: isDirectAccessTherapySupported,
        },
        [ProgramCustomerPropertyId.guidedSelfCareEnabled]: {
          isEnabled: isGuidedSelfCareEnabled,
        },
        [ProgramCustomerPropertyId.clinicalLeaveEvaluation]: {
          isEnabled: isClinicalLeaveEvaluationEnabled,
        },
      },
      healthPlanInformation: {
        healthPlanData,
        healthPlanConfig,
      },
    }
    return healthPlanAndEligibilityData
  }, [
    programCoverageBreakdown,
    isAlcoholUseDisorderTherapyEnabled,
    isBlendedCareMedsAvailable,
    isLCTherapyAvailable,
    isCoachingEnabled,
    isCoachingForParentsEnabled,
    isDAMedsAvailable,
    isDirectAccessTherapySupported,
    isGuidedSelfCareEnabled,
    isClinicalLeaveEvaluationEnabled,
    healthPlanData,
    healthPlanConfig,
  ])
}
